import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito conocimientos financieros previos?',
    a: "No, este libro se enfoca en preparar tu 'maquinaria interna' para que cualquier estrategia financiera que apliques funcione mejor."
  }, {
    q: '¿Es un libro de meditación?',
    a: 'Es un manual práctico que incluye desde hábitos físicos hasta gestión emocional, todo orientado a la ejecución de riqueza.'
  }, {
    q: '¿Cuánto tiempo me tomará leerlo?',
    a: 'Está diseñado para una lectura directa y accionable que puedes terminar en un fin de semana.'
  }, {
    q: '¿Realmente influye la salud en mi dinero?',
    a: 'Absolutamente. Un cerebro inflamado toma decisiones costosas. Un cuerpo sano produce riqueza constante.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-cream text-brand-dark py-24 px-6" data-id="element-38">
      <div className="max-w-3xl mx-auto" data-id="element-39">
        <FadeIn data-id="element-40">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-brand-dark" data-id="element-41">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-42">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-43">
              <div className="border border-gray-200 rounded-sm bg-white overflow-hidden" data-id="element-44">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-45">
                  <span className="font-bold text-lg text-brand-green" data-id="element-46">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-47" />
                </button>
                <AnimatePresence data-id="element-48">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-49">
                      <div className="px-6 pb-5 text-brand-dark/70 font-light leading-relaxed" data-id="element-50">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}